import styled from 'styled-components';

export const StyledCivilParty = styled.div`
  .civil_party {
    min-height: 198px;
    display: flex;
    flex-direction: column;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 24px;
  }
  .sub_div {
    height: 106px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: auto;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 16px;
  }
  .add-new-civil-party-style {
    padding: 10px 16px;
  }
  .title {
    text-align: left;
    letter-spacing: 0px;
    color: #2b2727;
    font-size: 18px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: bold;
  }

  .sub_title {
    font-size: 16px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Normal;
    letter-spacing: 0px;
    color: #707070;
  }
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  .sub_div_on_writing {
    height: 270px;
    padding: 24px;
  }
  .text {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
    margin-bottom: 10px;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
  }
  .check_box_div {
    min-width: 100px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    margin-right: 16px;
    padding: 0 12px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
  }
  .MuiFormControlLabel-root {
    margin-right: 0;
  }
  .MuiFormControlLabel-label {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
  }

  .civil-party-save-button {
    width: 90px;
    height: 36px;
    margin: 0 5px;
  }

  .civil-party-cancel-button {
    width: 90px;
    height: 36px;
    margin: 0 5px;
  }

  .button_container {
    display: flex;
    margin-top: 26px;
  }

  .victim-name {
    font-size: 13px;
    font-family: Roboto;
    font-weight: Medium;
    letter-spacing: 0px;
    color: #2b2727;
  }

  .add-button {
    min-width: 319px;
  }
  .title-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .delete-button {
    width: 123px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .add-icon {
    width: 20;
  }

  .upload-document {
    margin: 25px 0 16px 0;
  }
  .upload-doc-title {
    font-size: 14px;
    font-weight: bold;
    color: #2b2727;
  }
  .upload-document-button {
    margin-top: 16px;
    font-weight: normal;
    font-size: 14px;
    padding: 10px;
    min-width: 220px;
  }
  .cloud-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  #primary-button-style {
    margin-right: 16px;
    height: 36px;
  }
  #secondary-button-style {
    height: 36px;
  }
`;
